import {Mapper} from '@s-ui/domain'

export class FromDraftEntityToDraftFormValueObject extends Mapper {
  constructor({config, draftFormVO}) {
    super({config})
    this._config = config
    this._draftFormVO = draftFormVO
  }

  setParams(data) {
    this._data = data
    return this
  }

  map() {
    return this._draftFormVO({
      id: this._data.id,
      adTitle: this._data.adTitle,
      bodyTypeDoors: this._data.body,
      carPlate: this._data.carPlate,
      colour: this._data.colour,
      colourExtra: this._data.colourExtra,
      comments: this._data.comments,
      email: this._data.email,
      environmentalLabel: this._data.environmentalLabel,
      fuelId: this._data.fuel,
      hidePhone: this._data.hidePhone,
      images: this._data.images,
      mileage: this._data.km,
      makeId: this._data.make,
      modelId: this._data.model,
      phone: this._data.phone,
      plateRegistrationDate: this._data.plateRegistrationDate,
      price: this._data.price,
      provinceId: this._data.province,
      publishInMA: this._data.publishInMA,
      transmissionTypeId: this._data.transmission,
      userId: this._data.userId,
      versionId: this._data.version,
      year: this._data.year,
      zipCode: this._data.zipCode
    })
  }
}
